import { getItem, setItem } from '../../../utils/storage'
import { SearchResponse } from '../types'

const removeDuplicates = (results: SearchResponse[]) => {
  return results.filter((result, index, self) => index === self.findIndex((r) => r.entityID === result.entityID))
}

export const useRecentSearches = () => {
  const recentSearchesMaxLength = 2

  const addResultsToLocalstorage = (results: SearchResponse[]) => {
    const resultsToStore = results.slice(0, recentSearchesMaxLength)
    setItem('recentSearches', resultsToStore)
  }

  const getResultsFromLocalStorage = (): SearchResponse[] => {
    const results = getItem<SearchResponse[]>('recentSearches')
    if (results && Array.isArray(results)) {
      const resultsWithoutDuplicates = removeDuplicates(results)
      return resultsWithoutDuplicates
    }
    return []
  }

  const addResult = (result: SearchResponse) => {
    const results = getResultsFromLocalStorage()
    const updatedResults = [result, ...results]
    const updatedResultsWithoutDuplicates = removeDuplicates(updatedResults)
    addResultsToLocalstorage(updatedResultsWithoutDuplicates || [])
  }

  return {
    addResult,
    recentResults: getResultsFromLocalStorage(),
  }
}
